import React, { useEffect, useState } from "react";
import { useAuth } from "../../config/AuthContext";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ReactMarkdown from "react-markdown";
import { renderers } from "../../config/markdown";

const useStyles = makeStyles((theme) => ({
  markdownPost: {
    marginTop: theme.spacing(5),
    fontWeight: 900,
    color: theme.palette.text.secondary,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    "& .MuiTypography-root": {
      textAlign: "center",
    },
  },
  postTitle: {
    fontWeight: 900,
    fontSize: "3rem",
  },
  reactMarkdowns: {
    margin: theme.spacing(10, 0),
    overflowWrap: "break-word",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    "& img": {
      maxWidth: "100%",
      padding: theme.spacing(1),
    },
    "& pre": {
      background: "#000",
      borderRadius: "0.25rem",
      width: "100%",
      padding: theme.spacing(1),
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      "& code": {
        margin: theme.spacing(2),
        color: theme.palette.primary.contrastText,
        overflowWrap: "break-word",
        overflowX: "auto",
      },
    },
  },
}));

const MarkdownPost = ({ blogKey }) => {
  const classes = useStyles();
  const { dbRef, increment } = useAuth();
  const [title, setTitle] = useState("");
  const [author, setAuthor] = useState("");
  const [date, setDate] = useState("");
  const [post, setPost] = useState("Loading...");
  const [eTR, setETR] = useState(0);

  useEffect(() => {
    dbRef.child(`blogs/${blogKey}`).update({
      BlogViews: increment,
    });
  }, []);

  useEffect(() => {
    const unsubscribe = dbRef
      .child(`blogs/${blogKey}`)
      .once("value", async (snapshot) => {
        const snap = await snapshot.val();
        setTitle(snap.BlogTitle);
        setAuthor(snap.BlogAuthor);
        setDate(snap.BlogDate);
        setPost(snap.BlogPost);
        setETR(Math.ceil(post.split(" ").length / 200));
      });
    return unsubscribe;
  }, [blogKey, dbRef, post]);

  return (
    <div className={classes.markdownPost}>
      <Typography className={classes.postTitle}>{title}</Typography>
      <Typography variant="body1" component="span">
        {author} | {date} | {eTR} min read
      </Typography>
      <ReactMarkdown
        children={post}
        renderers={renderers}
        className={classes.reactMarkdowns}
      />
    </div>
  );
};

export default MarkdownPost;
